import Prismic from 'prismic-javascript';

let client;

const CMSUtils = {
    init() {
        const apiEndpoint = 'https://spothero.prismic.io/api/v2';

        client = Prismic.client(apiEndpoint);
    },
    getPageData({slug, customType, cookies}) {
        // if path has multiple parts, only use last part of path
        let cleanedSlug = slug;

        if (slug.includes('/')) {
            const path = slug.split('/').filter(Boolean);

            cleanedSlug = path[path.length - 1];
        }

        // check for Prismic preview cookie to enable previews of unpublished Prismic content
        const prismicCookie = cookies?.['io.prismic.preview']
            ? JSON.parse(cookies['io.prismic.preview'])
            : null;
        const previewCookie =
            prismicCookie?.['spothero.prismic.io']?.preview || null;

        /* The below code uses query instead of the getByUID helper function so that we can include the preview cookie ref to support previews of unpublished content. Predicates can be used to query documents and custom types.
        https://prismic.io/docs/reactjs/query-the-api/how-to-query-the-api
        https://prismic.io/docs/reactjs/query-the-api/query-predicates-reference */
        return client
            .query(Prismic.Predicates.at(`my.${customType}.uid`, cleanedSlug), {
                ...(previewCookie && {
                    ref: previewCookie,
                }),
            })
            .then(result => {
                if (!result?.results?.length) {
                    // eslint-disable-next-line no-throw-literal
                    throw {
                        status: 404,
                        message: `Page with slug ${slug} does not exist in Prismic data`,
                    };
                } else {
                    return result.results[0].data;
                }
            });
    },
};

export default CMSUtils;
